module.exports = __webpack_public_path__ + "oneCover.72aefa9bebbb80fc9753.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/one/oneCover.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/one/oneCover.jpg
// module chunks = 0